import styles from "./SingleAddressInfo.module.css";
import useAxios from "../Hooks/useAxios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
const SingleAddressInfo = ({ addressNo, data, changeAddress }) => {
  const data1 = {
    postal_code: "",
    prefecture: "",
    municipality: "",
    Building_number: "",
    phone: "",
    kanji_first_name: "",
    kanji_last_name: "",
    furigana_first_name: "",
    furigana_last_name: "",
  };
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const axios = useAxios();
  const navigate = useNavigate();
  const fetchAddress = () => {
    let value = data.postal_code;
    let zipsearch = value;
    if (value.length > 7) {
      zipsearch = value.replace(/[- ]/g, "");
    }
    zipsearch = parseInt(zipsearch);
    axios
      .post(backend_base + "/user/get/jp/address", {
        zipcode: zipsearch,
      })
      .then((response) => {
        if (response.status === 200) {
          //goto next page
          const result = response.data.address_data.results[0];
          console.log(result);
          changeAddress(addressNo, {
            ...data,
            prefecture: result["address1"],
            municipality: result["address2"] + " " + result["address3"],
            postal_code: value,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleChange = (e) => {
    let temp = JSON.parse(JSON.stringify(data));
    temp[e.target.name] = e.target.value;
    changeAddress(addressNo, temp);
  };
  const handleDelete = (id) => {
    axios
    .delete(backend_base + "/user/address/" + id)
    .then((res) => {
      if (res.status === 201 || res.status === 200) {
        console.log("Successfully Deleted Child");
        window.location.reload();
      }
    })
    .catch((e) => {
      console.log(e);
      window.location.reload();
    });
  };
  return (
    <div className={styles.main_box}>
      <div className={styles.cross} onClick={() => handleDelete(data.id)}>X</div>
      <div className={styles.sub_box}>
      <div className={styles.header01}>
        {addressNo === 1 ? "別送住所1" : "別送住所2"}
      </div>
      <div className={styles.hr01} />
      <div className={styles.info_row_main_wrapper}>
        <div className={styles.col1_main}>
          <div className={styles.col1_row1}>
            <div className={styles.col1_label}>お名前</div>
            <div className={styles.col1_input_row1}>
              <input
                value={data.kanji_first_name}
                name="kanji_first_name"
                onChange={handleChange}
                className={styles.input_sm01}
                placeholder="姓"
              ></input>
              <input
                value={data.kanji_last_name}
                name="kanji_last_name"
                onChange={handleChange}
                className={styles.input_sm01}
                placeholder="名"
              ></input>
            </div>
          </div>
          <div className={styles.col1_row1}>
            <div className={styles.col1_label}>ふりがな</div>
            <div className={styles.col1_input_row1}>
              <input
                value={data.furigana_first_name}
                name="furigana_first_name"
                onChange={handleChange}
                className={styles.input_sm01}
                placeholder="せい"
              ></input>
              <input
                value={data.furigana_last_name}
                name="furigana_last_name"
                onChange={handleChange}
                className={styles.input_sm01}
                placeholder="めい"
              ></input>
            </div>
          </div>
          <div className={styles.col1_row1}>
            <div className={styles.col1_label}>携帯電話</div>
            <div className={styles.col1_input_row1}>
              <input
                value={data.phone}
                name="phone"
                onChange={handleChange}
                className={styles.input_sm01}
                placeholder="半角数字ハイフン不要"
              ></input>
            </div>
          </div>
        </div>
        <div className={styles.col2_main}>
          <div className={styles.row3_main}>
            <div className={styles.row_label03}>郵便番号</div>
            <div className={styles.input_row_03}>
              <input
                value={data.postal_code}
                name="postal_code"
                onChange={handleChange}
                className={styles.input_sm01}
                placeholder="半角数字ハイフン不要"
              />
              <div onClick={fetchAddress} className={styles.underline01}>
                郵便番号検索
              </div>
            </div>
          </div>
          <div className={styles.row3_main}>
            <div className={styles.row_label03}>都道府県</div>
            <div className={styles.input_row_03}>
              <input
                value={data.prefecture}
                name="prefecture"
                onChange={handleChange}
                className={styles.input_sm01}
              />
            </div>
          </div>
          <div className={styles.row4_main}>
            <div className={styles.row_label03}>市区町村以下</div>
            <div className={styles.input_row_03}>
              <input
                value={data.municipality}
                name="municipality"
                onChange={handleChange}
                className={styles.input_bg01}
                placeholder=""
              />
            </div>
          </div>
          <div className={styles.row4_main}>
            <div className={styles.row_label03}>建物名</div>
            <div className={styles.input_row_03}>
              <input
                value={data.Building_number}
                name="Building_number"
                onChange={handleChange}
                className={styles.input_bg01}
                placeholder=""
              />
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};
export default SingleAddressInfo;
